import React from 'react';

const icEdit = (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='15' cy='15' r='15' fill='#6347FF' />
        <path
            d='M19.018 7.71304L8 19.4266V21.6993H10.73L21.9301 10.4124L19.018 7.71304ZM10.73 20.4685L9.74301 19.4266L16.925 11.874L17.912 12.9159L10.73 20.4685ZM17.905 10.832L18.8991 9.797L19.886 10.839L18.8991 11.881L17.905 10.832Z'
            fill='white'
        />
    </svg>
);

export default icEdit;
